import React from 'react'
import PropTypes from 'prop-types'
import Joyride from 'react-joyride'

/* Onbaording (via react-joyride) experience for Discover Explorer page */
export default class UMapExplorerOnBoarding extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    run: PropTypes.bool.isRequired
  }

  render () {
    // This fills up the logs quite a bit...so let's disable it by default.
    const debug = false
    return (
      <Joyride
        steps={this._steps()}
        run={this.props.run}
        debug={debug}
        continuous
        controlled
        showProgress
        showSkipButton
      />
    )
  }

  _steps () {
    const common = {
      placement: 'auto',
      placementBeacon: 'auto',
      disableBeacon: false,
      styles: {
        options: {
          zIndex: 10000
        }
      },
      locale: { skip: 'Skip tour' }
    }
    let steps = [
      {
        ...common,
        content: (<p>Welcome to the Diesel Labs Discover dashboard!<br/><br/>The Media Map visualization illuminates the entire spectrum of content broken out by key parameters such as distribution type, network or genre.<br/><br/>Proximity of data points in the visualization indicate a heavier overlap and/or similarity of audience members.<br/><br/></p>),
        disableBeacon: true,
        target: '.nsewdrag' // class name of the plotly map
      },
      {
        ...common,
        content: (<p>Use the ‘box select’ or ‘lasso select’ tools in the top left hand corner to explore different areas of the Map.<br/><br/> While in ‘select’ mode, double click anywhere in the map to reset the view and explore other areas.<br/><br/> The statistics panels will update based on your selections in the Media Map.<br/><br/>Let's Go!</p>),
        target: '#discoverRight'
      },
      {
        ...common,
        content: (<p>Toggle to the Content Analysis dashboard to explore content catalogs at the network or platform level.<br/><br/>Let's Go!</p>),
        target: '#rediscoverNav'
      }
    ]

    return steps
  }
}
